module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_9005.5369bc8f.png";